export const blockIconsPlacesFreeBreakfast = (
	<span className='material-symbols-outlined'>free_breakfast</span>
);
